import React from "react";
import { useTranslation } from "react-i18next";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { PlusIcon } from "@common/assets/plusIcon";
import { Props } from "./types";
import { CostProfiles } from "./costProfiles";
import styles from "./styles.scss";

function Sidebar(props: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.sidebar}>
      <div className={styles.costProfiles}>
        <div className={styles.header}>
          <h3 className={styles.title}>
            {t("costProfilesPage.sidebar.costProfiles")}
          </h3>
          <div
            className={styles.button}
            onClick={() =>
              pushView({
                key: UseCases.createCostProfile,
                data: undefined,
              })
            }
          >
            <PlusIcon className={styles.icon} />
          </div>
        </div>
        <div className={styles.costProfiles}>
          <CostProfiles />
        </div>
      </div>
    </div>
  );
}

export { Sidebar };
